<template>
  <div style="text-align:right; margin: 10px 0;">
    <!--<label :for="id" class="file__label">{{this.fileName || this.fileURL || "Select file"}}</label>-->
    <svg width="0" height="0" style="position: absolute;">
      <symbol id="uploadcare--icon-localhistory" viewBox="0 0 32 32">
        <g>
          <path d="M21.3,5c-2.9-1.3-6.2-1.4-9.2-0.2C10.1,5.6,8.3,6.9,7,8.6L6.5,6.8C6.4,6.2,5.9,5.9,5.3,6C4.8,6.2,4.5,6.7,4.6,7.2l1,4.1   c0.1,0.5,0.5,0.8,1,0.8c0.1,0,0.2,0,0.2,0l4.1-1c0.5-0.1,0.9-0.7,0.7-1.2C11.6,9.3,11,9,10.5,9.2L8.8,9.6c1.1-1.3,2.4-2.3,4-2.9   c2.5-1,5.2-0.9,7.7,0.2c2.4,1.1,4.3,3,5.3,5.5c1,2.5,0.9,5.2-0.2,7.7s-3,4.3-5.5,5.3c-3.5,1.3-7.4,0.7-10.2-1.8   c-1.2-1.1-2.2-2.4-2.8-3.9c-0.2-0.5-0.8-0.8-1.3-0.6c-0.5,0.2-0.8,0.8-0.6,1.3c0.7,1.8,1.9,3.5,3.3,4.7c2.2,1.9,5,2.9,7.9,2.9   c1.5,0,2.9-0.3,4.3-0.8c3-1.2,5.3-3.4,6.6-6.3c1.3-2.9,1.4-6.2,0.2-9.2S24.3,6.3,21.3,5z"/>
          <path d="M16.5,10c-0.6,0-1,0.4-1,1v6c0,0.3,0.1,0.6,0.4,0.8l4,3c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.6-0.1,0.8-0.4   c0.3-0.4,0.2-1.1-0.2-1.4l-3.6-2.7V11C17.5,10.4,17.1,10,16.5,10z"/>
        </g>
      </symbol>
    </svg>
    <svg width="0" height="0" style="position: absolute;">
      <symbol id="uploadcare--icon-googlesearch" viewBox="0 0 900 900">
        <g transform="translate(0.000000,900.000000) scale(0.100000,-0.100000)">
          <path d="M4320 8624 c-1565 -141 -2920 -1153 -3493 -2609 -257 -654 -342 -1347 -251 -2060 212 -1668 1471 -3072 3114 -3474 510 -124 1029 -151 1620 -85 1160 131 2072 666 2665 1564 206 312 342 595 467 975 210 635 279 1391 187 2040 -19 132 -64 374 -72 382 -2 1 -916 6 -2030 10 l-2027 6 0 -936 0 -937 1035 0 c595 0 1035 -4 1035 -9 0 -5 -27 -61 -59 -124 -147 -288 -359 -534 -616 -715 -100 -70 -310 -179 -435 -225 -333 -124 -734 -164 -1100 -111 -960 139 -1716 895 -1867 1865 -24 157 -24 481 0 638 138 887 784 1604 1642 1820 193 48 328 65 535 65 558 2 1033 -178 1479 -557 l93 -80 679 679 c374 373 678 683 676 689 -5 15 -202 191 -314 283 -832 673 -1906 1001 -2963 906z"/>
        </g>
      </symbol>
    </svg>
    <svg width="0" height="0" style="position: absolute;">
      <symbol id="uploadcare--icon-pexels" viewBox="0 0 32 32">
        <g transform="translate(0.000000,32.000000) scale(0.01,-0.01)" stroke="none">
          <path d="M105 2983 c-44 -23 -65 -44 -86 -85 -18 -36 -19 -82 -19 -1398 0 -1316 1 -1362 19 -1398 22 -42 43 -63 88 -86 29 -14 158 -16 1393 -16 1316 0 1362 1 1398 19 42 22 63 43 86 88 14 29 16 158 16 1393 0 1235 -2 1364 -16 1393 -23 45 -44 66 -86 88 -36 18 -82 19 -1400 19 -1224 -1 -1366 -2 -1393 -17z m1687 -834 c221 -46 379 -241 379 -467 0 -146 -47 -261 -148 -357 -51 -49 -162 -110 -219 -121 l-34 -6 0 -179 0 -179 -370 0 -370 0 0 660 0 660 355 0 c219 0 374 -4 407 -11z"/>
          <path d="M1220 1500 l0 -460 180 0 180 0 0 174 0 174 98 4 c110 5 152 21 214 84 59 58 83 117 83 199 -1 118 -60 210 -169 261 -50 23 -58 24 -318 24 l-268 0 0 -460z"/>
        </g>
      </symbol>
    </svg>
    <svg width="0" height="0" style="position: absolute;">
      <symbol id="uploadcare--icon-pixabay" viewBox="0 0 32 32">
        <g transform="translate(0.000000,25.000000) scale(0.01,-0.01)" stroke="none">
          <path d="M1406 1972 c-10 -17 -106 -297 -106 -310 0 -10 15 -12 58 -10 l57 3 30 90 c16 50 30 91 31 93 1 2 636 -237 642 -243 1 -1 -32 -90 -74 -196 -41 -107 -80 -204 -85 -216 l-8 -23 -53 21 c-88 36 -83 37 -80 -30 l4 -60 90 -36 c50 -20 95 -34 100 -33 14 5 259 631 250 639 -10 8 -828 319 -841 319 -5 0 -12 -4 -15 -8z"/>
          <path d="M840 1649 c0 -43 -18 -59 -65 -59 l-45 0 0 -290 0 -290 510 0 510 0 0 290 0 290 -328 0 c-328 0 -329 0 -349 23 -11 12 -23 30 -26 40 -6 15 -20 17 -107 17 -94 0 -100 -1 -100 -21z m647 -175 c78 -45 112 -142 79 -227 -75 -196 -367 -160 -384 48 -13 161 159 262 305 179z"/>
          <path d="M1340 1423 c-31 -11 -70 -58 -76 -90 -13 -69 41 -133 113 -133 87 0 145 81 110 155 -27 56 -94 87 -147 68z"/>
          <path d="M1560 588 c0 -206 3 -238 19 -273 79 -170 319 -183 411 -22 70 122 17 278 -112 331 -24 11 -69 16 -128 16 l-90 0 0 90 0 90 -50 0 -50 0 0 -232z m297 -68 c18 -10 39 -33 48 -49 60 -117 -71 -239 -183 -171 -45 27 -62 74 -62 165 l0 75 83 0 c64 0 89 -4 114 -20z"/>
          <path d="M497 644 c-4 -4 -7 -110 -7 -236 l0 -228 50 0 50 0 -2 233 -3 232 -40 3 c-23 2 -44 0 -48 -4z"/>
          <path d="M630 636 c0 -5 6 -17 14 -25 16 -19 136 -190 136 -195 0 -2 -38 -54 -85 -115 -47 -62 -85 -114 -85 -117 0 -2 28 -4 63 -4 l62 1 55 75 c30 42 58 78 62 80 3 2 32 -32 65 -76 l58 -79 63 -1 c57 0 77 10 52 25 -5 3 -43 53 -85 110 l-76 104 76 106 c41 58 75 109 75 113 0 4 -28 6 -63 4 l-62 -3 -49 -75 -49 -75 -34 48 c-19 26 -42 60 -50 75 -15 23 -23 27 -80 30 -35 2 -63 -1 -63 -6z"/>
          <path d="M1253 639 c-59 -11 -96 -32 -136 -79 -92 -108 -65 -269 57 -345 48 -29 52 -30 203 -33 l153 -3 0 128 c0 70 -5 144 -10 164 -32 115 -149 188 -267 168z m112 -119 c43 -27 48 -39 54 -148 l6 -92 -81 0 c-68 0 -87 4 -115 23 -66 44 -83 121 -42 184 35 54 120 69 178 33z"/>
          <path d="M140 624 c-45 -19 -97 -69 -121 -116 -17 -34 -19 -60 -19 -273 l0 -235 50 0 50 0 0 90 0 90 90 0 c103 0 147 14 199 63 95 90 95 244 0 334 -19 18 -51 39 -71 47 -47 20 -132 20 -178 0z m145 -98 c91 -39 99 -173 12 -226 -25 -16 -50 -20 -114 -20 l-83 0 0 80 c0 93 15 131 63 160 38 24 75 25 122 6z"/>
          <path d="M2163 610 c-137 -79 -157 -256 -41 -367 56 -54 91 -63 248 -63 l140 0 0 140 c0 157 -9 192 -63 248 -49 52 -97 72 -169 72 -52 0 -72 -6 -115 -30z m185 -90 c45 -27 62 -74 62 -165 l0 -75 -75 0 c-43 0 -90 6 -110 14 -74 31 -99 136 -48 196 14 18 36 36 47 40 37 15 90 11 124 -10z"/>
          <path d="M2540 503 c0 -124 3 -143 24 -188 25 -54 71 -100 123 -122 43 -17 125 -17 170 2 44 18 43 18 43 0 0 -8 -15 -32 -33 -52 -30 -32 -41 -37 -90 -41 l-57 -4 0 -50 0 -50 69 4 c81 4 135 34 178 100 l28 41 3 249 3 248 -51 0 -50 0 0 -141 0 -141 -33 -33 c-57 -57 -132 -59 -185 -5 -36 36 -42 64 -42 206 l0 114 -50 0 -50 0 0 -137z"/>
        </g>
      </symbol>
    </svg>
    <input :id="id" class="file" type="hidden" :role="'uploadcare-uploader-' + id" data-crop="free, 1:1, 2:1, 4:1, 3:1, 1:2, 16:9"/>
    <font-awesome-icon icon="spinner" v-if="uploading" class="fa-spin" />
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { uploadFile, uploadRemoteFile } from '../../lib/api/calls'
import '@fortawesome/fontawesome/styles.css';
import fontawesome from '@fortawesome/fontawesome';
import { faSpinner } from '@fortawesome/fontawesome-free-solid';

fontawesome.config = {
  autoAddCss: false,
};

fontawesome.library.add(faSpinner);

export default {
  name: 'FileUpload',
  components: {
    FontAwesomeIcon
  },
  props: ['id', 'defaultValue'],
  methods: {
    update(value){
      // if it's an image return all the info
      this.$emit('input', value.sizes ? value : value.url);
    },
    onFileGiven(e){
      // Depreciated
      var input = event.target;
      let file = input.files[0];

      var reader = new FileReader();
      this.uploading = true;
      reader.onload = function(){
        var dataURL = reader.result;

        uploadFile(dataURL, file).then(function(data){
          this.uploading = false;
          return data.json();
        }.bind(this)).then(function(json){
          if(json.url){
            this.file = json;
            this.fileURL = json.url;
          }
        }.bind(this));
      }.bind(this)

      if(file) {
        reader.readAsDataURL(file);
        this.fileName = file.name;
      } else {
        this.uploading = false;
      }
    },
    upload_it(fileName, remoteUrl, extType){
      this.uploading = true;
      uploadRemoteFile(remoteUrl, extType).then(function(data){
        this.uploading = false;
        return data.json();
      }.bind(this)).then(function(json){
        if(json.url){
          this.file = json;
          this.fileURL = json.url;
        }
      }.bind(this));

      if (remoteUrl) {
        this.fileName = fileName;
      } else {
        this.uploading = false;
      }
    }
  },
  mounted () {
    const widget = uploadcare.Widget('[role=uploadcare-uploader-' + this.id + ']');
    let func = this;
    widget.onUploadComplete(function(info) {
      func.upload_it(info.name, info.cdnUrl, info.mimeType)
    })
  },
  data(){
    return {
      file: this.defaultValue || null,
      fileURL: this.defaultValue || null,
      fileName: null,
      uploading: false
    }
  },
  watch: {
    fileURL(newVal){
    },
    file(newVal) {
      this.update(newVal)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/FileUpload.vue